/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

// Import child components for different user navigation
import NavSponsor from "./Childs/Navs/NavSponsor";
import NavArtist from "./Childs/Navs/NavArtist";
import { useGlobal } from "../../context/GlobalContextProvider";
import { useWallet } from "../../context/WalletContextProvider";

// Nav component to conditionally render navigation items for "sponsor" or "artist" user types
export default function Nav() {
  const { account } = useWallet(); // Get the connected wallet account
  const { userType, menuState, campaign, artPack, setMenuState } = useGlobal(); // Get user type from session storage

  // Function to render the appropriate navigation component based on `userType`
  const navbar = () => {
    if (userType === "sponsor") {
      // Return the NavSponsor component if the user is a "sponsor"
      return (
        <NavSponsor
          campaign={campaign}
          artPack={artPack}                    // Campaign data
          isWalletConnected={account != null}  // Wallet connection status
          menuState={menuState}                  // Data for conditional checks
          setMenuState={setMenuState}
        />
      );
    } else if (userType === "artist") {
      // Return the NavArtist component if the user is an "artist"
      return (
        <NavArtist
          artPack={artPack}                     // Art pack data
          isWalletConnected={account != null} // Wallet connection status
          menuState={menuState}                 // Data for conditional checks
          setMenuState={setMenuState}
        />
      );
    }
    else {
      return;
    }
  };

  // Render the sidebar navigation wrapper, which includes the appropriate nav component based on `userType`
  return (
    <>
      <div className="border-end border-top bg-white" id="sidebar-wrapper">
        <div className="list-group list-group-flush font-nav">
          {navbar()} {/* Call navbar function to render appropriate navigation component */}
        </div>
      </div>
    </>
  );
}
